import { Paper, Box, Button, Dialog, DialogContent, DialogContentText, IconButton, Typography } from '@mui/material'
import LineChartContainer from './LineChartContainer'
import { useContext, useState } from 'react';
import CustomShaped from '../styled/CustomShaped';
import CloseIcon from '@mui/icons-material/Close';
import BarChartContainer from './BarChartContainer';
import { ViewportContext } from '../../contexts/viewportContext';

export default function ChartContainer({ visual }: { visual: any }) {

    const vpContext = useContext(ViewportContext);

    const [showEnlargedVisual, setShowEnlargedVisual] = useState(false);

    const handleClose = () => {
        setShowEnlargedVisual(false)
    }

    return (
        <>
            <Paper elevation={0}
                sx={{
                    bgcolor: 'transparent',
                    position: 'relative',
                    boxSizing: 'border-box'
                }}>
                {visual.chart_type === 'bar' && <BarChartContainer visual={visual}></BarChartContainer>}
                {visual.chart_type === 'line' && <LineChartContainer visual={visual}></LineChartContainer>}
                <Box sx={{
                    marginTop: 1,
                    display: 'grid',
                    placeContent: 'center'
                }}>
                    <Button variant='text'
                        onClick={() => setShowEnlargedVisual(true)}
                        sx={{
                            width: 'max-content',
                            color: '#00A9B1',
                            fontWeight: 600,
                            textDecoration: 'underline',
                            padding: 0,
                            lineHeight: 1,
                        }}>Enlarge Visual</Button>
                </Box>

            </Paper>
            {
                visual && <Dialog
                    open={showEnlargedVisual}
                    onClose={handleClose}
                    fullWidth={true}
                    maxWidth={vpContext?.is4k ? 'xl' : 'lg'}
                    sx={{
                        background: '#CCCCCC87',
                        '& .MuiDialog-paper': {
                            boxShadow: 'none',
                            filter: 'drop-shadow(0px 0px 0.12vw #009CA4) drop-shadow(0px 0px 15px black)',
                            backgroundColor: 'transparent !important'
                        }
                    }}>

                    <CustomShaped borderSize={'none'}>
                        <DialogContent sx={{
                            boxSizing: 'border-box',
                            padding: 1,
                            background: 'white',
                        }}>
                            <DialogContentText component={'div'}>
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                }}>
                                    {visual.title && visual.title.length > 0 && <Typography variant='h5' sx={{
                                        fontWeight: 600,
                                        width: '75%',
                                        color: '#000000',
                                        borderBottom: '2px solid #000000',
                                        textWrap: 'balance',
                                        paddingY: 1,
                                    }}>
                                        {visual.title}
                                    </Typography>}
                                    <IconButton disableRipple
                                        onClick={handleClose}
                                        sx={{
                                            height: 'max-content',
                                            marginLeft: "auto",
                                            transition: 'all 200ms ease-in-out',
                                            '&:hover': {
                                                scale: 1.25,
                                            }
                                        }}>
                                        <CloseIcon htmlColor='#000000' />
                                    </IconButton>
                                </Box>
                                <Box>
                                    {visual.chart_type === 'bar' && <BarChartContainer visual={visual} enalrged={true}></BarChartContainer>}
                                    {visual.chart_type === 'line' && <LineChartContainer visual={visual} enalrged={true}></LineChartContainer>}
                                </Box>
                            </DialogContentText>
                        </DialogContent>
                    </CustomShaped>
                </Dialog>
            }</>
    )
}
